module.exports = __webpack_public_path__ + "img/test2.b59b51c6.svg";